// extracted by mini-css-extract-plugin
var _1 = "HomeView-module__activities--ZgDQa";
var _2 = "HomeView-module__animateUploadProgressBarWidth--XImMt";
var _3 = "HomeView-module__animatedBackground--PTUAZ";
var _4 = "HomeView-module__asideActivitiesContainer--R8zn2";
var _5 = "HomeView-module__asideHeader--HgNvw";
var _6 = "HomeView-module__isHomeActivitiesV2--Wq2Dl";
var _7 = "HomeView-module__main--mNVF8";
export { _1 as "activities", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "asideActivitiesContainer", _5 as "asideHeader", _6 as "isHomeActivitiesV2", _7 as "main" }
